import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { useNavigation } from '@refinedev/core';
import { Form, Input, Select, Switch, message } from 'antd';
import { WorkoutPlanType } from '@wellverse/shared-ts';

export const WorkoutPlanEdit: React.FC = () => {
  const { formProps, saveButtonProps, onFinish } = useForm({ resource: 'workout-plans' });
  const { push } = useNavigation();

  React.useEffect(() => {
    if (formProps.form && formProps.initialValues?.schedule) {
      formProps.form.setFieldsValue({
        schedule: typeof formProps.initialValues.schedule === 'object'
          ? JSON.stringify(formProps.initialValues.schedule, null, 2)
          : formProps.initialValues.schedule,
      });
    }
  }, [formProps.form, formProps.initialValues]);

  const handleSubmit = async (values: Record<string, unknown>) => {
    try {
      if (values.schedule && typeof values.schedule === 'string') {
        try {
          values.schedule = JSON.parse(values.schedule);
        } catch {
          // leave as-is if not valid JSON
        }
      }
      await onFinish(values);
      message.success('Workout plan updated');
      push('/workout-plans');
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Failed to update workout plan';
      message.error(msg);
    }
  };

  return (
    <Edit resource="workout-plans" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical" onFinish={(v) => { void handleSubmit(v); }}>
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input placeholder="e.g. 7-Day Strength Plan" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={4} placeholder="Describe the workout plan..." />
        </Form.Item>
        <Form.Item label="Plan Type" name="planType">
          <Select placeholder="Select plan type">
            {Object.values(WorkoutPlanType).map((t) => (
              <Select.Option key={t} value={t}>{t}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Public" name="isPublic" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item
          label="Rest between exercises"
          name="restBetweenExercises"
          valuePropName="checked"
          initialValue={true}
          tooltip="Show a full-screen rest after each completed exercise. Turn off for HYROX-style continuous plans."
        >
          <Switch />
        </Form.Item>
        <Form.Item label="Schedule (JSON)" name="schedule">
          <Input.TextArea rows={4} placeholder='{"monday": "chest", "tuesday": "back"}' />
        </Form.Item>
      </Form>
    </Edit>
  );
};
